// import alert from '@/plugins/alert'
import { StudentMenu, Class, MealTransfer } from '@/plugins/api'
import { rangeRight } from 'lodash-es'
import moment from 'moment'

export default {
  namespaced: true,
  state: {
    loading: false,
    studentMenuData: {},
    count: 0,
    search: [],
    pageText: '',
    itemsPerPage: 10,
    studentMenuSearchParams: {},
    totalItems: 0,
    studentMenus: [],
    date: moment().startOf('day').toISOString(),
  },
  actions: {
    async getMenuRegisterByStudents({ commit }, query) {
      commit('changeState', { loading: true })
      const timeGte = moment(query.date).startOf('day')
      let lastTimeToEat = timeGte.clone().add(13, 'hours')
      if (timeGte.toISOString() === '2023-10-28T17:00:00.000Z') {
        lastTimeToEat = moment('2023-10-31T12:00:00.000Z')
      }
      query = {
        ...query,
        lastTimeToEat: lastTimeToEat.toISOString(),
      }
      const studentMenus = await StudentMenu.getMenuRegisterByStudents(query)
      commit('changeState', { studentMenus, studentMenuSearchParams: query, loading: false })
    },
    async searchStudentMenuList({ commit, state, dispatch }, query) {
      const studentMenuSearchParams = {
        _limit: state.itemsPerPage,
        ...query,
      }

      commit('changeState', { studentMenuSearchParams })
      dispatch('requestPageSettings', {})
    },
    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage }) {
      commit('changeState', { loading: true })
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      if (state.studentMenuSearchParams) {
        const studentMenuSearchParams = {
          ...state.studentMenuSearchParams,
          date: state.date,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          _sort: 'nameToNumber:ASC',
        }
        const [totalItems, studentMenus] = await Promise.all([
          StudentMenu.count(studentMenuSearchParams),
          StudentMenu.search(studentMenuSearchParams),
        ])
        await Promise.all(
          studentMenus.map(async (sm) => {
            const currentClass = await Class.fetchOne(sm.student.currentClass)
            sm.class = currentClass
          })
        )
        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            studentMenus,
            totalItems,
            itemsPerPage,
            studentMenuSearchParams,
          })

          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('setPageText', pageText)
        } else {
          var pages = rangeRight(1, page)
          for (let index = 0; index < pages; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }

      commit('changeState', { loading: false })
    },
    async createStudentMenu(_, studentMenuData) {
      const c = await StudentMenu.create(studentMenuData)
      return c
    },
    async updateStudentMenu(_, { id, ...studentMenuData }) {
      const d = await StudentMenu.update(id, studentMenuData)
      //   commit('updateStudentMenu', d)
      return d
    },
    async removeStudentMenu({ commit }, id) {
      await StudentMenu.remove(id)
      commit('removeStudentMenu', id)
    },
    setStudentMenu({ commit }, studentMenuData) {
      commit('setStudentMenu', studentMenuData)
    },
    setDate({ commit }, date) {
      commit('changeState', { date })
    },
    async removeMealTransfer(_, id) {
      await MealTransfer.remove(id)
    },
    async createMealTransfer(_, data) {
      const c = await MealTransfer.create(data)
      return c
    },
    async updateMealTransfer(_, { id, ...data }) {
      const d = await MealTransfer.update(id, data)
      return d
    },
  },
  mutations: {
    setPageText(state, pageText) {
      state.pageText = pageText
    },
    updateStudentMenu(state, studentMenuData) {
      const studentMenus = state.studentMenus.map((c) => {
        if (studentMenuData.id === c.id) return studentMenuData
        else return c
      })
      state.studentMenus = studentMenus
    },
    removeStudentMenu(state, id) {
      const studentMenus = state.studentMenus.filter((d) => d.id !== id)
      state.studentMenus = studentMenus
    },
  },
  getters: {},
}
